(function () {
    function monitorSavedCoursesChange(keyName, callback) {
        const isFirefoxOrIOS = /firefox|iphone|ipad|ipod|safari/i.test(navigator.userAgent);

        const originalSetItem = isFirefoxOrIOS ? Storage.prototype.setItem : localStorage.setItem;
        const originalRemoveItem = isFirefoxOrIOS ? Storage.prototype.removeItem : localStorage.removeItem;
        const target = isFirefoxOrIOS ? Storage.prototype : localStorage;

        target.setItem = function (key, value) {
            if (key === keyName) {
                setTimeout(() => {
                    const event = new CustomEvent('localStorageChange', {
                        detail: { key, newValue: value }
                    });
                    window.dispatchEvent(event);
                    callback(value);
                }, 0);
            }
            return originalSetItem.apply(this, arguments);
        };

        target.removeItem = function (key) {
            if (key === keyName) {
                setTimeout(() => {
                    const event = new CustomEvent('localStorageChange', {
                        detail: { key, newValue: null }
                    });
                    window.dispatchEvent(event);
                    callback(null);
                }, 0);
            }
            return originalRemoveItem.apply(this, arguments);
        };

        window.addEventListener('storage', e => {
            if (e.key === keyName) {
                callback(e.newValue);
            }
        });
    }

    // expose globally
    window.monitorSavedCoursesChange = monitorSavedCoursesChange;
})();